import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EntrySummaryShortModel } from '@data-layer/models/entry-summaries';
import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import {
  enumEntrySummaryState,
  enumEntrySummarySubmissionType,
  enumStatementState,
  enumTransportationMode,
} from '@data-layer/enums/entry-summaries';
import { ShipmentModel } from '@data-layer/models/common';
import { enumCompanyPlacement } from '@enum/enumCompanyPlacement';
import { MarineInsuranceAvailabilityService } from '@shared/marine-insurance-shared/services';

@Component({
  selector: 'es-list-detail',
  templateUrl: './es-list-detail.component.html',
  styleUrls: ['./es-list-detail.component.scss'],
})
export class EsListDetailComponent implements OnInit {
  @Input() public es: EntrySummaryShortModel;
  @Input() public lastShown: boolean = false;
  @Output() public update: EventEmitter<any> = new EventEmitter();
  @Output() public editInternalNotes: EventEmitter<void> = new EventEmitter<void>();
  @Output() public openChat: EventEmitter<void> = new EventEmitter<void>();

  public DEFAULT_CURRENCY_CODE: string = DEFAULT_CURRENCY_CODE;
  public enumESTransportationMode: typeof enumTransportationMode = enumTransportationMode;
  public enumESStatementState: typeof enumStatementState = enumStatementState;
  public enumCompanyPlacement: typeof enumCompanyPlacement = enumCompanyPlacement;
  public isShowDetails: boolean;
  public isShowAllBills: boolean = false;

  constructor(private marineInsuranceAvailabilityService: MarineInsuranceAvailabilityService) {}

  public ngOnInit(): void {}

  public afterDeleteES() {
    this.update.emit();
  }

  public get showPaidDate(): boolean {
    return !!this.es.statement.paidDate && !this.es.releaseDate;
  }

  public get showReleasedDate(): boolean {
    return !!this.es.releaseDate;
  }

  public get showAuthorizedDate(): boolean {
    return (
      (this.es.statement.authorizedDate || this.es.statement.state === enumStatementState.AUTHORIZATION_REJECTED) &&
      !this.es.statement.paidDate
    );
  }

  public get showBrokerMessages(): boolean {
    // #13113: in the broker-review flow a state-50 ES has no sentToProviderDate yet (the broker sends it after approve)
    return (
      this.es.submissionType === enumEntrySummarySubmissionType.BROKER_ASSISTED &&
      (!!this.es.sentToProviderDate || this.es.state === enumEntrySummaryState.BROKER_REVIEW_PENDING)
    );
  }

  public get isValidShipment(): boolean {
    // #13047: For Truck mode, Master BL number is optional — only the carrier is required.
    if (this.isTruck) {
      return this.entryShipments.every((item: ShipmentModel) => !!item?.masterBill?.carrier);
    }
    return this.entryShipments.every(
      (item: ShipmentModel) =>
        (!!item?.houseBill?.carrier && !!item?.houseBill?.number) || (!!item?.masterBill?.carrier && !!item?.masterBill?.number),
    );
  }

  public get entryShipments(): ShipmentModel[] {
    return (this.es?.shipments || []).slice(0, 2);
  }

  public get isTruck(): boolean {
    return this.es?.transportationMode === enumTransportationMode.TRUCK;
  }

  public get isShowInsuranceIndicator(): boolean {
    return this.marineInsuranceAvailabilityService.isShowIndicatorForEntrySummary(this.es);
  }
}
